import React from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Box,
} from "@material-ui/core";
import logo from "../../assets/img/stripe.logo.svg";
import { privacyPolicy, stripeURL } from "../../services/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "380px",
      marginLeft: "64px",
      left: 0,
      right: 0,
      bottom: 32,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      position: "absolute",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    mainText: {
      color: theme.palette.dark.light,
      fontSize: "0.8rem",
      lineHeight: "1rem",
      marginRight: "12px",
    },
    logoContainer: {
      display: "flex",
      alignItems: "center",
      width: "200px",
      paddingBottom: "42px",
    },
    logoImg: {
      maxWidth: "100%",
      display: "block",
      height: "auto",
      maxHeight: "40px",
    },
    divider: {
      marginLeft: "12px",
    },
    dividerText: {
      color: theme.palette.dark.light,
      fontSize: "1rem",
      lineHeight: "1rem",
      marginRight: "12px",
    },
    privacyLink: {
      textDecoration: "none !important",
      color: theme.palette.dark.light,
    },
  })
);

export default function LeftPanelFooter() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Typography className={classes.mainText}>{t("powered_by")}</Typography>
      <a href={stripeURL}>
        <img
          src={logo}
          alt="Stripe Logo"
          className={classes.logoImg}
          draggable={false}
        />
      </a>
      <Box className={classes.divider}>
        <Typography className={classes.dividerText}>|</Typography>
      </Box>
      <a
        className={classes.privacyLink}
        href={privacyPolicy}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("privacy")}
      </a>
    </Box>
  );
}
